// Shared by the login and reset password screens: a plain page with the logo, one line of help,
// large fields and a full-width button.
export const createAuthStyles = ({ ui: { colors, layout, radius, space, touch, type } }) => ({
	container: {
		flex: 1,
		backgroundColor: colors.canvas,
	},
	content: {
		flexGrow: 1,
		justifyContent: 'center',
		paddingHorizontal: space.xl,
		paddingBottom: 48,
	},
	form: {
		width: '100%',
		maxWidth: layout.maxContentWidth,
		alignSelf: 'center',
	},
	logoWrap: {
		alignItems: 'center',
		marginBottom: space.xl,
	},
	title: {
		...type.title,
		textAlign: 'center',
		color: colors.text,
		marginBottom: 6,
	},
	subtitle: {
		...type.body,
		textAlign: 'center',
		color: colors.textSecondary,
		marginBottom: 28,
	},
	input: {
		height: touch.primaryButton,
		minHeight: touch.primaryButton,
		marginBottom: space.md,
		paddingHorizontal: 14,
		borderRadius: radius.card,
		fontSize: type.body.fontSize,
	},
	button: {
		marginTop: 6,
	},
	link: {
		minHeight: touch.min,
		marginTop: space.md,
		alignItems: 'center',
		justifyContent: 'center',
	},
	linkPressed: {
		opacity: 0.7,
	},
	linkText: {
		...type.bodySmallStrong,
		color: colors.accent,
	},
});
